import { createTableEmptyState, type TableEmptyStateStyles } from '@gokrew/ui';
import styles from './TableEmptyState.module.css';

const TableEmptyState = createTableEmptyState(styles as TableEmptyStateStyles);
export default TableEmptyState;
export type { TableEmptyStateProps } from '@gokrew/ui';
